import React from 'react';
import {Box} from '@mui/material';
import {
  Body,
  Icon,
  Label,
  designSystemToken,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './FeedEmptyState.module.scss';

function FeedEmptyState() {
  return (
    <Box className={styles.feedEmptyState}>
      <Icon
        name="Actions-Comment2"
        size="large"
        appearance="neutral"
        color={designSystemToken('semantic.fg.inverse-secondary')}
      />
      <Label
        size="md"
        color={designSystemToken('semantic.fg.inverse-secondary')}
      >
        {translate('No comments yet')}
      </Label>
      <Body
        size="sm"
        color={designSystemToken('semantic.fg.inverse-secondary')}
      >
        {translate('Leave a comment or approve this asset')}
      </Body>
    </Box>
  );
}

export default FeedEmptyState;
